(ns frontend.view.grid.screening.db
  (:require
   [frontend.db :as app-db]
   [reagent.core :as r]))

(defonce screening-profiles (r/cursor app-db/views [:screening-grid]))
(defonce grid-entities (r/cursor screening-profiles [:grid-entities]))
(defonce view-settings (r/cursor screening-profiles [:view-settings]))
(defonce screening-profile-filters (r/cursor view-settings [:filters]))
(defonce selected-columns (r/cursor view-settings [:selected-columns]))
(defonce column-widths (r/cursor view-settings [:column-widths]))
(defonce ordered-columns (r/cursor view-settings [:ordered-columns]))

;;kanban related definitions
(defonce kanban (r/cursor screening-profiles [:kanban]))
(defonce expanded (r/cursor kanban [:expanded]))
(defonce grouped-by (r/cursor view-settings [:grouped-by]))
(defonce card-settings (r/cursor view-settings [:card-settings]))
(defonce lists (r/cursor kanban [:lists]))
(defonce sorted-kanban-entities (r/cursor screening-profiles [:sorted-kanban-entities]))

;;precalculated schema (for performance reasons):
(defonce schema (r/cursor screening-profiles [:schema]))
